import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

//main module
import robuxModule from './robuxModule';

//main scss file
import '../../../css/robux/robux.scss';

//all other files that we want attached to the module.
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./directives/", true, /\.js$/));

// import all entry files
// premium
import premiumEntry from "../premium/premiumEntry.js";

//main module templates
const templateContext = require.context("./", true, /\.html$/);
const templates = templateCacheGenerator(angular, 'robuxHtmlTemplateApp', templateContext, null);

//self manual initialization
angular.element(function () {
    angular.bootstrap("#robux-page", [robuxModule.name, templates.name]);
});
export default robuxModule;